import axios from 'axios';

const api = axios.create({ baseURL: 'https://projects.ckellycreative.com/api' });



api.interceptors.request.use(
  (config) => {
	const token = localStorage.getItem('token');
    if (config.method != 'get' && token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);


/**
 * Wrap the interceptor in a function, so that it can be re-instantiated
 */
const createAxiosResponseInterceptor = () => {
    const interceptor = api.interceptors.response.use(
        (response) => response,
        (error) => {
            // Reject promise if usual error
            if (error.response.status !== 401) {
                return Promise.reject(error);
            }

            /*
             * When response code is 401, try to refresh the token.
             * Eject the interceptor so it doesn't loop in case
             * token refresh causes the 401 response.
             *
             * Must be re-attached later on or the token refresh will only happen once
             */
            api.interceptors.response.eject(interceptor);

            return api
                .post(`/?rest_route=/simple-jwt-login/v1/auth/refresh&JWT=${localStorage.getItem('token')}`)
                .then((response) => {
					localStorage.setItem('token', response.data.data.jwt)
                    error.response.config.headers.Authorization =
                        `Bearer ${response.data.data.jwt}`;
                    // Retry the initial call, but with the updated token in the headers. 
                    // Resolves the promise if successful
                    
                    return api(error.response.config);
                })
                .catch((error2) => {
                    // Retry failed, clean up and reject the promise
					localStorage.setItem('token', '')
                    return Promise.reject(error2);
                })
                .finally(createAxiosResponseInterceptor); // Re-attach the interceptor by running the method
        }
    );
}
createAxiosResponseInterceptor(); // Execute the method once during start

export default api;

/*


let isRefreshing = false;

api.interceptors.response.use(
  response => response,
  async error => {
    const token = localStorage.getItem('token');
    const originalRequest = error.config;
    if (error.response.status === 401 && !originalRequest._retry) {
      if (!isRefreshing) {
        isRefreshing = true;
        // Refresh token logic here
        axios
            .post(`https://mooncal.ckellycreative.com/api/?rest_route=/simple-jwt-login/v1/auth/refresh&JWT=${token}`)
            .then((response) => {
            	console.log('originalRequest', originalRequest)
     			originalRequest.headers.Authorization = `Bearer ${response.data.jwt}`
				localStorage.setItem('token', response.data.jwt)
             })
            .catch((err) => {
                console.log(err.message);
            })
            .finally((response) => {
				originalRequest._retry = true;
            	return console.log('ModoriginalRequest', originalRequest)
        		//return api(originalRequest);
            });
      }
    }
    return Promise.reject(error);
  }
);

*/